import * as SwitchPrimitive from '@radix-ui/react-switch';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '../../lib/utils';

export interface SwitchProps
  extends ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> {
  label?: string;
}

export const Switch = forwardRef<
  HTMLButtonElement,
  SwitchProps
>(({ label, disabled, id, className, ...props }, ref) => {
  const switchId = id || (label ? `switch-${label.toLowerCase().replace(/\s+/g, '-')}` : undefined);

  return (
    <div className="flex items-center gap-ds-2">
      <SwitchPrimitive.Root
        ref={ref}
        id={switchId}
        disabled={disabled}
        className={cn(
          'relative w-[44px] h-[24px] rounded-full border-none p-[2px] cursor-pointer bg-ds-grey-mid data-[state=checked]:bg-ds-accent disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      >
        <SwitchPrimitive.Thumb
          className="block w-[20px] h-[20px] bg-white rounded-full transition-transform data-[state=checked]:translate-x-[20px]"
        />
      </SwitchPrimitive.Root>
      {label && (
        <label
          htmlFor={switchId}
          className={cn(
            'font-ds-sans text-sm',
            disabled
              ? 'text-ds-text-secondary cursor-not-allowed'
              : 'text-ds-text cursor-pointer'
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
});

Switch.displayName = 'Switch';
